import { defineStore } from "pinia"

export const usePresentationStore = defineStore("presentationStore", {
  state: () => ({
    open: false,
    teacherToolsTarget: null as HTMLElement | null,
  }),

  actions: {
    start() {
      this.open = true
      // Fullscreen is optional, the presentation works in the window when the browser refuses it
      document.documentElement.requestFullscreen().catch(() => {})
    },
  },
})
